import { Select } from "../select";
import { CloseIcon, MagnifyingGlassIcon } from "../../../assets";
import React, { useCallback, useEffect, useState } from "react";

type FilterSelectUsersProps = {
  headerText: string;
  onFilter: (value: Array<string> | undefined) => void;
};

type OptionsStatus = {
  value: string;
  label: string;
};

const options = [
  {
    value: "approved",
    label: "Approved",
  },
  {
    value: "counter",
    label: "Countered",
  },
  {
    value: "rejected",
    label: "Rejected",
  },
];

export const FilterSelectStatus = ({
  headerText,
  onFilter,
}: FilterSelectUsersProps): React.ReactElement => {
  const [value, setValue] = useState<Array<OptionsStatus>>([]);
  const [name, setName] = useState<string | undefined>();

  const handleChange = (options: Array<OptionsStatus>): void => {
    setValue(options);
  };

  const getOptionLabel: (option: OptionsStatus) => string = useCallback(
    (option: OptionsStatus) => option.label,
    []
  );

  const statusOptions = name
    ? options.filter((option) => option.value.startsWith(name))
    : options;

  useEffect(() => {
    if (Array.isArray(value) && value.length > 0) {
      onFilter(value.map((option) => option.value));
    } else {
      onFilter(undefined);
    }
  }, [onFilter, value]);

  return (
    <section className="relative">
      <div
        className={` top-0 flex h-5 w-full  max-w-[110px] items-center justify-between rounded-[5px] bg-[#FFFFFF] py-1 pl-3 pr-1 ${
          value.length ? "shadow-[2px_2px_2px_rgba(0,0,0,0.15)]" : ""
        }`}
      >
        <Select<OptionsStatus>
          multiselect
          name="status"
          className="w-32"
          classNameContainer="w-[calc(100%-20px)]"
          value={value}
          searchValue={name ?? ""}
          asyncFilter={(value) => setName(value)}
          onChange={(newValue) => {
            handleChange(newValue as Array<OptionsStatus>);
          }}
          options={statusOptions}
          renderOptionComponent={getOptionLabel}
          labelProp="label"
          placeholder="Status"
          customInput={(event) => {
            return (
              <div className="w-full" onClick={event} role="presentation">
                <input
                  value={
                    value.length > 1
                      ? "Mutiple selected"
                      : value.length === 1
                      ? value[0].label
                      : ""
                  }
                  className={`w- z-[100] h-full w-full truncate p-0 text-[10px] outline-0 ${
                    value.length ? "block" : " hidden"
                  }`}
                  placeholder={headerText}
                  autoFocus
                  disabled
                />

                <div
                  className={`flex w-full flex-row items-center justify-center ${
                    value.length ? "hidden" : "visible"
                  }`}
                  role="presentation"
                >
                  <span className="mr-[10px] text-[11px]">{headerText}</span>
                  <section className="h-[14px] w-[14px] items-center justify-center">
                    <MagnifyingGlassIcon fill="#147EFB" />
                  </section>
                </div>
              </div>
            );
          }}
        />
        {value.length ? (
          <div className="flex items-center">
            <button
              onClick={() => {
                setValue([]);
              }}
            >
              <CloseIcon
                className="text-sm text-[#147EFB]"
                width={18}
                height={18}
              />
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
};
